import { useFormatGoalAmount } from "web_myplann/Goals/Helpers/formatGoalAmount";
import { formatGoalRentLabel } from "web_myplann/Goals/Helpers/formatGoalRentLabel";
import { formatGoalSummarySegment } from "web_myplann/Goals/Helpers/formatGoalSummarySegment";
import { mapToGoalRentSummary } from "web_myplann/Goals/Helpers/mapToGoalRentSummary";
import { mapToGoalSummarySegments } from "web_myplann/Goals/Helpers/mapToGoalSummarySegments";
import type { GoalDetail } from "web_myplann/Goals/Types/GoalDetail";
import type {
	GoalSummary,
	GoalSummarySegmentFormatOptions,
} from "web_myplann/Goals/Types/GoalSummary";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";

export const useGoalSummaryLine = (goal: GoalDetail): GoalSummary | null => {
	const { t } = useResource();
	const formatAmount = useFormatGoalAmount();

	const options: GoalSummarySegmentFormatOptions = {
		category: goal.category,
		currencyCode: goal.currencyCode,
		t,
		formatAmount,
	};

	const segments = mapToGoalSummarySegments(goal).map((segment) =>
		formatGoalSummarySegment(segment, options),
	);

	const rent = mapToGoalRentSummary(goal);
	const rentLabel = rent ? formatGoalRentLabel(rent, options) : null;

	if (!rentLabel && segments.length === 0) return null;

	return { rentLabel, segments };
};
